 /* jshint esversion: 6 */
 import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";
import {
  asyncRouterMap,
  constantRouterMap as routes,
} from "@/configs/router.config";
const router = createRouter({
  routes,
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
